var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"iframe-redirect-overlay"},[_c('iframe',{staticClass:"iframe-redirect-overlay__frame",attrs:{"name":"paycore-redirect-iframe","allow":"payment","sandbox":"allow-scripts allow-same-origin allow-forms allow-popups allow-modals","frameborder":"0","allowfullscreen":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }